export function isPersistentAdminQueryError(error) {
  const status = error?.response?.status
  return status === 401 || status === 403 || status === 500 || status === 503
}

export function shouldRetryAdminQuery(failureCount, error) {
  if (isPersistentAdminQueryError(error)) return false
  return failureCount < 1
}

export function adminQueryErrorText(error, fallback) {
  const status = error?.response?.status
  const detail = error?.response?.data?.detail
  if (typeof detail === 'string' && detail.trim()) return detail
  if (status === 403) return 'Accès administrateur refusé par le serveur.'
  if (status === 503) return 'Service administratif indisponible : configuration serveur.'
  return fallback
}
